import Image from 'next/image'
import { type FC } from 'react'

import { type PimCautionV1 } from '@redteclab/api/clients/bully'

import { useExperimentalAddStaticFileHost } from '../../../../experiments/new-cdn-experiment/useExperimentalAddStaticFileHost'
import { useGlobalConfigContext } from '../../../../global-config'
import { productAccessorGetCautions } from '../../../model/productAccessor/productAccessorGetCautions'
import { useProductPageContext } from '../../productPageContext'
import { ProductDescriptionSection } from '../ProductDescriptionSection'

const MAX_IMAGE_HEIGHT = 110
const MAX_IMAGE_WIDTH = 98

export const ProductDescriptionCautions: FC = () => {
  const { product } = useProductPageContext()
  const { tenant } = useGlobalConfigContext()

  const cautions: PimCautionV1[] = productAccessorGetCautions(product, tenant)

  const { addStaticCdnHostToUrl } = useExperimentalAddStaticFileHost()

  if (cautions.length === 0) {
    return null
  }

  return (
    <>
      {cautions.map((section) =>
        section.laymen_text && section.pictogram_url ? (
          <div
            className="mb-5 flex w-full flex-col items-center rounded-2xl bg-light-primary-medium px-4 py-5 mobile-md:flex-row"
            key={section.code}
          >
            <Image
              alt={product.name}
              className="mb-5 max-h-full max-w-full flex-none mobile-md:mb-0 mobile-md:mr-4"
              data-analytics="item-image"
              height={MAX_IMAGE_HEIGHT}
              src={addStaticCdnHostToUrl(section.pictogram_url)}
              unoptimized
              width={MAX_IMAGE_WIDTH}
            />
            <ProductDescriptionSection
              section={{
                content: section.laymen_text,
                header: undefined,
              }}
            />
          </div>
        ) : null,
      )}
    </>
  )
}
